import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

import { Backdrop, Button } from 'core/ui/atoms';
import BodyScrollManager from 'core/ui/components/BodyScrollManager';
import { ReactComponent as CloseButton } from 'core/assets/images/V2/icons/CloseInvertIcon.svg';

class ErrorModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    ctaText: PropTypes.string,
    onCtaClick: PropTypes.func,
    inverse: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    title: 'Error Title',
    ctaText: 'ERROR CTA',
  };

  render() {
    const { inverse, onClose, title, description, ctaText, onCtaClick } = this.props;

    return ReactDOM.createPortal(
      <ModalWrap>
        <ModalTable>
          <ModalCell>
            <BodyScrollManager disabled={true} />
            <Backdrop $inverse={inverse} onClick={onClose} />
            <CSSTransition appear in classNames="modal" timeout={600}>
              <ModalContainer className={this.props.className}>
                {onClose && <Close onClick={() => onClose()} />}
                <ContentWrapper>
                  <Title>{title}</Title>
                  {description && <Description>{description}</Description>}
                  <CtaButton btn-primary onClick={onCtaClick}>{ctaText}</CtaButton>
                </ContentWrapper>
              </ModalContainer>
            </CSSTransition>
          </ModalCell>
        </ModalTable>
      </ModalWrap>,
      document.getElementById('modal-root'),
    );
  }
}

const ModalWrap = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: scroll;
  z-index: ${(p) => p.theme.zIndex.modal};
`;

const ModalTable = styled.div`
  display: table;
  width: 100vw;
  height: 100%;
  vertical-align: middle;
`;

const ModalCell = styled.div`
  position: relative;
  display: table-cell;
  vertical-align: middle;
  ${(p) => p.theme.min('md')`
    padding: 40px;
  `}
`;
const ModalContainer = styled.div`
  position: relative;
  width: 450px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, .5);
  margin: 0 auto;
  z-index: 2;
  border-radius: 4px;
  padding: 40px 30px;

  &.modal-appear {
    transform: translate(0, -50%);
  }
  &.modal-appear-active {
    transform: translate(0, 0);
    transition: all 300ms ease-out;
  }
  &.modal-exit {
    transform: translate(0, 0);
  }
  &.modal-exit-active {
    transform: translate(0, -50%);
    transition: all 300ms ease-in;
  }

  ${(p) => p.theme.max('sm')`
    width: 90%;
    min-height: auto;
    padding: 20px;
    height: 344px;
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 30px;
`;

const Title = styled.h2`
  color: #985639;
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.9px;
`;

const Description = styled.p`
  color: ${(p) => p.theme.typography.colors.primary};
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 40px;
`;

const CtaButton = styled(Button)`
  width: 90%;
  background: ${(p) => p.theme.colors.error || '#FF6B6B'};
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  text-transform: uppercase;
  border-radius: 4px;
  background: #F6D0BF;
  color: #000;
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 1.5px;
`;

const Close = styled((p) => <CloseButton {...p} />)`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  color: ${(p) => p.theme.colors.textSecondary};
`;

export default ErrorModal;
